import React from "react";
import google from "../../../assets/google-logo.svg";
import { PropsType } from "./types/PropsTypes";

const StepThree = ({ prevStep, nextStep }: PropsType) => {
  return (
    <section className="sm:py-10 sm:py-8 py-6 bg-white-sm-light sm:min-h-[calc(100vh-152px)] min-h-[calc(100vh-96px)]">
      <div className="mx-auto max-w-2xl px-4">
        <div className="md:p-8 sm:p-6 p-4 sm:rounded-2xl rounded-xl bg-white md:mb-6 sm:mb-4 mb-3">
          <h4 className="sm:text-base text-sm font-medium mb-2">UX UI Designer</h4>
          <h4 className="flex items-center text-dark-black lg:text-base text-sm">
            <img className="mr-2 md:w-6 w-5 md:h-6 h-5" src={google} alt="" />{" "}
            Company Name{" "}
          </h4>
        </div>
        <div className="md:p-8 sm:p-6 p-4 bg-white sm:rounded-2xl rounded-xl">
          <h4 className="sm:text-xl text-base font-medium sm:mb-6 mb-4">Additional Questions</h4>
          <form action="#" method="GET">
            <div className="mb-4">
              <label
                htmlFor="country"
                className="block sm:text-base text-sm font-medium leading-6 text-gray-900 mb-2"
              >
                Question 1
              </label>
              <div className="mt-2">
                <input
                  name="country"
                  type="text"
                  required
                  className="sm:text-base text-sm block w-full py-1.5 text-gray-900 shadow-sm h-14 border-0 bg-white-gray ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-inset focus:ring-yellow-300 sm:text-sm sm:leading-6 sm:px-4 px-3 rounded-lg"
                  placeholder="Type here"
                />
              </div>
            </div>
            <div className="mb-4">
              <label
                htmlFor="country"
                className="block sm:text-base text-sm font-medium leading-6 text-gray-900 mb-2"
              >
                Question 2
              </label>
              <div className="mt-2">
                <input
                  name="country"
                  type="text"
                  required
                  className="sm:text-base text-sm block w-full py-1.5 text-gray-900 shadow-sm h-14 border-0 bg-white-gray ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-inset focus:ring-yellow-300 sm:text-sm sm:leading-6 sm:px-4 px-3 rounded-lg"
                  placeholder="Type here"
                />
              </div>
            </div>
            <div className="mb-4">
              <label
                htmlFor="country"
                className="block sm:text-base text-sm font-medium leading-6 text-gray-900 mb-2"
              >
                Question 3
              </label>
              <div className="mt-2">
                <input
                  name="country"
                  type="text"
                  required
                  className="sm:text-base text-sm block w-full py-1.5 text-gray-900 shadow-sm h-14 border-0 bg-white-gray ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-inset focus:ring-yellow-300 sm:text-sm sm:leading-6 sm:px-4 px-3 rounded-lg"
                  placeholder="Type here"
                />
              </div>
            </div>
            <div className="mb-4">
              <label
                htmlFor="country"
                className="block sm:text-base text-sm font-medium leading-6 text-gray-900 mb-2"
              >
                Question 4
              </label>
              <div className="mt-2">
                <input
                  name="country"
                  type="text"
                  required
                  className="sm:text-base text-sm block w-full py-1.5 text-gray-900 shadow-sm h-14 border-0 bg-white-gray ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-inset focus:ring-yellow-300 sm:text-sm sm:leading-6 sm:px-4 px-3 rounded-lg"
                  placeholder="Type here"
                />
              </div>
            </div>
          </form>
        </div>
        <div className="sm:mt-10 mt-6 text-end">
          <a
            onClick={prevStep}
            className="inline-block md:py-4 py-3 md:px-10 px-6 rounded-lg bg-shade-gray font-medium sm:text-base text-sm"
          >
            Back
          </a>
          <div
            onClick={nextStep}
            className="inline-block md:py-4 py-3 md:px-10 px-6 rounded-lg bg-amber-300 font-medium sm:text-base text-sm ml-6"
          >
            Next
          </div>
        </div>
      </div>
    </section>
  );
};

export default StepThree;
